import classNames from 'classnames/bind'

const FieldGroup = props => (
  <div className={classNames({
    'field': true,
    'is-horizontal': props.horizontal,
    'with-error': props.error
  })}>
    {
      props.label &&
      <div className={classNames({
        'field-label grow-2 has-text-left': true,
        [`is-${props.size}`]: props.size
      })}>
        <label className="label">{props.label}</label>
      </div>
    }
    {
      props.labelOffset &&
      <div
        className={classNames({
          'field-label grow-2': true,
          [`is-${props.size}`]: props.size
        })}
      >
        <label className="label">&nbsp;</label>
      </div>
    }
    <div className="field-body">
      {props.children}
    </div>
  </div>
)

FieldGroup.defaultProps = {
  disabled: false,
  size: 'small'
}

export default FieldGroup



// WEBPACK FOOTER //
// ./components/uiLib/FieldGroup/FieldGroup.js